import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';

import { ScrollingListService } from 'src/app/ajs-upgraded-providers';

import { BillingApiService } from 'src/app/api/services/billing-api.service';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { CurrentPlanService } from 'src/app/components/plans/current-plan.service';
import { BroadcasterService } from 'src/app/shared/services/broadcaster.service';
import { BillingUtilsService } from '../../services/billing-utils.service';
import { InvoiceService } from '../../services/invoice.service';

@Component({
    selector: 'billing',
    templateUrl: './billing.component.html',
    styleUrls: ['./billing.component.scss'],
    standalone: false
})
export class BillingComponent implements OnDestroy {

  private subscription;
  protected subscriptionsDisplayedColumns = ['subscription', 'status', 'renewalDate', 'planAmount', 'shipTo'];
  protected invoicesDisplayedColumns = ['status', 'date', 'description', 'amount', 'invoice', 'actions', 'shipTo'];
  public company = this.companyStateService.getCopyOfSelectedCompany();

  public subscriptions = this.scrollingListService(this.billingApiService.getSubscriptions.bind(this.billingApiService), {
    name: 'Subscriptions',
    onListUpdate: () => {
      this.changeDetectorRef.detectChanges();
    }
  });
  public invoices = this.scrollingListService(this.billingApiService.getInvoices.bind(this.billingApiService), {
    name: 'Invoices',
    onListUpdate: () => {
      this.changeDetectorRef.detectChanges();
    }
  });

  constructor(
    private broadcaster: BroadcasterService,
    private changeDetectorRef: ChangeDetectorRef,
    private companyStateService: CompanyStateService,
    private scrollingListService: ScrollingListService,
    public currentPlanService: CurrentPlanService,
    private billingApiService: BillingApiService,
    protected billingUtils: BillingUtilsService,
    public invoiceService: InvoiceService
  ) {
    this.invoiceService.generateToken();

    this.subscription = this.broadcaster.on('risevision.company.planStarted', () => {
      this.subscriptions.doSearch();
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  showSubscriptionLink(subscription) {
    if (subscription.customer_id !== this.company.id) {
      return false;
    } else if (this.billingUtils.isCancelled(subscription)) {
      return false;
    }

    return true;
  }

}